module.exports = __webpack_public_path__ + "media/unipod/icon-tanking-black-ea75baf8.svg";